import { defineComponent, getCurrentInstance, ComponentInternalInstance, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { accountSmsLogin, getValidateCode, sendSms, checkRegisterPhone, initSignature } from '@/api/index'
import { Login } from '@/interface/index'
import { wxCode } from '@/utils/index'
import { Dialog } from 'vant'
import { useStore } from 'vuex'
import CashierWidget from '@/components/cashier'

import './index.less'

export default defineComponent({
    name: 'Login',
    setup () {
        const store = useStore()
        const { appContext } = getCurrentInstance() as ComponentInternalInstance
        const proxy = appContext.config.globalProperties
        const router = useRouter()
        const route = useRoute()
        const form: Login = {phone: '', verify: ''}
        const code = ref('') //验证码
        const codePic = ref('')
        const times = ref(30)
        const show = ref(true)


        onMounted(() => {
            onReloadCode()
             // 微信验证
             wxCode()
             //微信签名
             initSignature() 
        }) 

       //发送短信
       const onSendSms = async (data: Login) => {
        
           const res:any = await sendSms(data)  
           if (res.code === 0) {
            onCode() //调用倒计时
           }
           proxy.$toast(res.message);
       }

        //刷新验证码
       const onReloadCode = () => {
            const path = getValidateCode + '?phone=' + form.phone + '&verify=' + Math.random()
            codePic.value = path;
        }

        const verifyUI = () => {
             return (
                 <div>
                     <img class='tishi-icon' src='https://img.fanwoon.com/tishi.png' />
                     <img src={codePic.value} onClick={onReloadCode} />
                     <input class='code-box' v-model={ code.value } placeholder="请输入验证码" />
                 </div>
             )
        }

        const showVerify = () => {
            Dialog.confirm({
                    message: verifyUI,
                    closeOnClickOverlay: true,
                }).then(() => {
                if (!code.value) return proxy.$toast('请输入图形验证码!');
                
                onSendSms({phone: form.phone, verify: code.value})
                }).catch(() => {
                    console.log('cancel')
            });
        }

        const showConfirm = () => {
              Dialog.confirm({
                title: '该手机还未注册',
                message: '是否需要去注册该账号？',
                    closeOnClickOverlay: true,
                }).then(() => {
                    onRegister() //跳转注册
                }).catch(() => {
                    console.log('cancel')
            });
        }

        const onOpenVerify = async () => {
            if (!form.phone) return proxy.$toast('手机号不能为空!');
            if (code.value) {
                code.value = ''
                onReloadCode()
            }

            const res:any = await checkRegisterPhone(form.phone)
            if (res.data === 0 ) return showConfirm()
            showVerify()
        }

        // 登录
        const onLogin = async () => {
            if (!form.phone)return proxy.$toast('手机号不能为空!');
            const reg = /^1[1-9]\d{9}$/
            if(!reg.test(form.phone))return proxy.$toast('手机号有误!');
            if(!form.verify)return proxy.$toast('验证码不能为空!');

            const res: any = await accountSmsLogin(form)
            if (res.code !== 0) {
                return proxy.$toast(res.message);
            }
            proxy.$toast(res.message);
            store.commit('setUser', res.data)
            !route.query.redirect ? router.push({path: '/job'}) :
            router.push({path: `${route.query.redirect}`})
        }

        //注册.
        const onRegister = () => {
            router.push({path: '/register'})
        }

        //协议
        const onAreement = () => {
            router.push({path: '/areement'})
        }

        //倒计时
        const onCode = () => {
            show.value = false 
            let timer:any = setInterval(() => {
                times.value--
                if (times.value === 0) {
                    clearInterval(timer)
                    timer = null
                    show.value = true
                }
            }, 1000)
        }

        const onPwdLogin = () => {
            router.push({path: `/login2`, query: { redirect: route.query.redirect }}) //
        }

        return () => (
            <div class="login-page">
                <div class="login-content">
                    <img class="logo" src="https://img.fanwoon.com/new_logo.png" />
                    <div class="slogan-item">门店招聘</div>
                    <div class="form-list">
                        <div class="form-list-item">
                            <div class="item-label">手机号码</div>
                            <div><input v-model={form.phone} class="input-item w498" placeholder="请输入手机号码" /></div>
                        </div>
                        <div class="form-list-item">
                            <div>
                                <div class="item-label">短信验证码</div>
                                <div class="flex-box">
                                    <input v-model={form.verify } maxlength='4' autocomplete="off" class="input-item w313" placeholder="验证码" />
                                    {
                                        show.value ? <button class="button code-btn" onClick={onOpenVerify }>获取验证码</button> : 
                                    <button class="button code-btn non-btn">{ times.value }s获取验证码</button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="tab-font" onClick={onPwdLogin}>切换密码登录</div>
                        <div>
                            <button class="button login-btn" onClick={onLogin}>登录</button>
                            <button class="register-btn" onClick={onRegister}>注册翻腕，快速招人</button>
                        </div>
                    </div>
                </div>
                <div class="login-footer">
                        登录即代表您同意<span class="privet-info" onClick={onAreement}> 《翻腕服务协议》</span>
                </div>
                {/* <CashierWidget /> */}
            </div>
        )
    }
})